import { network } from 'services/network';

export const ENDPOINT = 'api/bo/getVersionSummaryCards';

export const getVersionSummaryCards = (params) => {
    return network.post(ENDPOINT, params).then((response) => {
        return response.data;
    });
};
